import { atom } from 'jotai';

import {
  Maybe,
  PlayerPositionAbbr,
  PlayerPositionAbbrF5,
  SelectValue,
} from '@/types';
import {
  PlayerClub,
  TacticOnField,
  Step,
  TemplatePlayer,
  PlayerHistoric,
  Player,
  PlayersOnFieldF5,
  PlayerF5,
  ResponseCurrentTeam,
} from '@/types/team';
import { PlayerMyTeamF5, ResponseInitMyF5 } from '@/types/teamf5';

export const emptyTeam: PlayerClub[] = [
  { orden: 0, capitan: false, titular: true },
  { orden: 1, capitan: false, titular: true },
  { orden: 2, capitan: false, titular: true },
  { orden: 3, capitan: false, titular: true },
  { orden: 4, capitan: false, titular: true },
  { orden: 5, capitan: false, titular: true },
  { orden: 6, capitan: false, titular: true },
  { orden: 7, capitan: false, titular: true },
  { orden: 8, capitan: false, titular: true },
  { orden: 9, capitan: false, titular: true },
  { orden: 10, capitan: false, titular: true },
  { orden: 11, capitan: false, titular: true },
  { orden: 12, capitan: false, titular: true },
  { orden: 13, capitan: false, titular: true },
  { orden: 14, capitan: false, titular: true },
];

export const emptyTeamF5: PlayerF5[] = [
  { orden: 0, capitan: false, seguro: false },
  { orden: 1, capitan: false, seguro: false },
  { orden: 2, capitan: false, seguro: false },
  { orden: 3, capitan: false, seguro: false },
  { orden: 4, capitan: false, seguro: false },
];

// An enum with all the types of actions to use in our reducer
export enum TeamActionTypes {
  SET_STATE = 'SET_STATE',
  RESET = 'RESET',
}

export interface TeamStateReducer {
  tactic?: {
    id: number;
    formation: number[];
  };
  responseTeamF11?: ResponseCurrentTeam;
  responseTeamF5?: ResponseInitMyF5;
  selectedPlayerOnBuildTeam?: Maybe<PlayerClub> | Maybe<PlayerF5>;
  selectedPlayerOnTeam?: Maybe<TemplatePlayer>;
  selectedPlayerOnList?: Maybe<TemplatePlayer>;
  playerIncoming?: Maybe<TemplatePlayer>;
  playerOutgoing?: Maybe<TemplatePlayer>;
  playersOnField?: TacticOnField;
  playersOnFieldF5?: PlayersOnFieldF5;
  balance?: number;
  tournamentPrice?: number;
  selectedPosition?: Maybe<PlayerPositionAbbr> | Maybe<PlayerPositionAbbrF5>;
  teamDraft?: PlayerClub[] | PlayerHistoric[] | Player[];
  team?: PlayerClub[] | PlayerHistoric[] | Player[];
  teamF5?: PlayerF5[] | PlayerMyTeamF5[];
  playerDetailsModalOpen?: boolean;
  addToTeamBySuggestionModal?: boolean;
  insurancedAndCaptainPlayerModalOpen?: boolean;
  teamIsComplete?: boolean;
  showPrevTeamModal?: boolean;
  storageOnboardingBuild?: Maybe<string>;
  storageOnboardingTeam?: Maybe<string>;
  showOnboarding?: boolean;
  showModalRecommender?: boolean;
  showFiltersPlayersList?: boolean;
  showPlayersList?: boolean;
  showPlayersListTransfer?: boolean | string;
  showModalChangePlayer?: boolean;
  tagsFiltersSelected?: string[];
  clonePlayersList?: TemplatePlayer[];
  filtersApplied?: {
    position?: Maybe<PlayerPositionAbbr>;
    positionF5?: Maybe<PlayerPositionAbbr[]>;
    orderBy?: Maybe<SelectValue>;
    orderClub?: Maybe<SelectValue>;
    intoBudget?: boolean;
    valuesRange?: Maybe<number[]>;
  };
  step?: Maybe<Step>;
  isBeforeVeda?: boolean;
}

interface ActionType {
  type: TeamActionTypes;
  payload?: TeamStateReducer;
}

export const initialState = atom<TeamStateReducer>({
  responseTeamF11: undefined,
  responseTeamF5: undefined,
  tactic: { id: 1, formation: [4, 4, 2] },
  selectedPlayerOnBuildTeam: null,
  selectedPlayerOnTeam: null,
  selectedPlayerOnList: null,
  playerIncoming: null,
  playerOutgoing: null,
  isBeforeVeda: false,
  playersOnField: {
    goalkeepers: null,
    defenders: [],
    midfielders: [],
    forwards: [],
    substitutes: [],
  },
  playersOnFieldF5: {
    goalkeeper: null,
    fieldPlayers: [],
  },
  balance: 0,
  tournamentPrice: 0,
  selectedPosition: null,
  teamDraft: emptyTeam,
  team: emptyTeam,
  teamF5: emptyTeamF5,
  playerDetailsModalOpen: false,
  addToTeamBySuggestionModal: false,
  teamIsComplete: false,
  showPrevTeamModal: false,
  storageOnboardingBuild: null,
  storageOnboardingTeam: null,
  showOnboarding: false,
  showModalRecommender: false,
  showFiltersPlayersList: false,
  showPlayersList: false,
  showPlayersListTransfer: false,
  showModalChangePlayer: false,
  tagsFiltersSelected: [],
  clonePlayersList: [],
  filtersApplied: {
    position: null,
    positionF5: null,
    orderBy: null,
    orderClub: null,
    intoBudget: false,
    valuesRange: null,
  },
  step: null,
});

export const teamReducer = (state: TeamStateReducer, action: ActionType) => {
  const { type, payload } = action;

  switch (type) {
    case TeamActionTypes.SET_STATE: {
      return {
        ...state,
        ...payload,
      };
    }

    case TeamActionTypes.RESET: {
      return {
        ...state,
        ...initialState,
      };
    }

    default: {
      return state;
    }
  }
};
